import { render, staticRenderFns } from "./SpecimenSpecificDetailsModal.vue?vue&type=template&id=6209c4b0&scoped=true"
import script from "./SpecimenSpecificDetailsModal.vue?vue&type=script&lang=js"
export * from "./SpecimenSpecificDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./SpecimenSpecificDetailsModal.vue?vue&type=style&index=0&id=6209c4b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6209c4b0",
  null
  
)

export default component.exports